import React from 'react';
import PropTypes from 'prop-types';

import render from './render';

export class User extends React.Component {
  static propTypes = {
    render: PropTypes.func,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string,
    email: PropTypes.string,
    onEdit: PropTypes.func,
    onDelete: PropTypes.func,
    classNames: PropTypes.string,
  };

  static defaultProps = {
    render,
    name: '',
    email: '',
    onEdit () {},
    onDelete () {},
  };

  onEdit = () => this.props.onEdit(this.props.id);

  onDelete = () => this.props.onDelete(this.props.id);

  render () {
    const { render: Render, ...nextProps } = this.props;
    const { onEdit, onDelete } = this;
    const props = {
      ...nextProps,
      onEdit,
      onDelete,
    };

    return <Render {...props} />;
  }
}

export default User;



// WEBPACK FOOTER //
// ./src/components/Admin/UsersManagement/UsersList/User/index.js